import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

export const paymentApi = createApi({
    baseQuery: fetchBaseQuery({
        baseUrl: process.env.REACT_APP_API_END_POINT,
        prepareHeaders: (headers) => {
            headers.set('Authorization', `Bearer ${sessionStorage.getItem('key')}`);
            return headers;
        },
    }),
    reducerPath: 'paymentApi',
    tagTypes: ['payment'],
    endpoints: (build) => ({
        getPayment: build.query({
            query: (id) => `payment-aggregator/payment/${id}`,
            providesTags: ['payment'],
        }),

        getPaymentSDK: build.query({
            query: (id) => `payment-aggregator/payment/${id}?isSDK=true`,
            providesTags: ['payment'],
        }),

        getPaymentOutcome: build.mutation({
            query: (id) => ({
                url: `payment-aggregator/payment/${id}`,
                method: "GET",
            }),
        }),

        updateRedirectPayment: build.mutation({
            query: ({ _id, ...rest }) => ({
                url: `payer-api/redirectResult/${_id}`,
                method: "PUT",
                body: rest
            }),
            invalidatesTags: ['payment'],
        }),

        executePayment: build.mutation({
            query: ({ id, ...rest }) => ({
                url: `payer-api/executePayment/${id}`,
                method: "POST",
                body: rest
            }),
        }),

        postePayIGFS: build.mutation({
            query: (id) => ({
                url: `payer-api/postePayIGFS/${id}`,
                method: "POST"
            }),
        }),

        postePayVerifyIGFS: build.mutation({
            query: (id) => ({
                url: `payer-api/verifyPostepay/${id}`,
                method: "GET"
            }),
        }),

        setBrowserInfo: build.mutation({
            query: ({ _id, ...browserInfo }) => ({
                url: `payer-api/browserInfo/${_id}`,
                method: "POST",
                body: browserInfo
            })
        }),

        directPayment: build.mutation({
            query: ({ _id, ...tokenization }) => ({
                url: `payer-api/directPayment/${_id}`,
                method: "POST",
                body: tokenization
            }),
            invalidatesTags: ['payment'],
        }),


        getIp: build.query({
            query: () => `${process.env.REACT_APP_API_END_POINT_IP}v1/payer-api/ipv4`,
        }),

        // PAYPAL
        createOrderPaypal: build.mutation({
            query: (id: string) => ({
                url: `direct-apm/paypal/createOrder/${id}`,
                method: "POST",
            }),
        }),

        captureOrderPaypal: build.mutation({
            query: (id: string) => ({
                url: `direct-apm/paypal/captureOrder/${id}`,
                method: "POST",
            }),
            invalidatesTags: ['payment'],
        }),

        deToken: build.mutation({
            query: (tokenization) => ({
                url: `payer-api/deToken`,
                method: "POST",
                body: tokenization
            }),
            invalidatesTags: ['payment'],
        }),

        //SPAY
        spayCreateTrx: build.mutation({
            query: ({id, phoneNumber}) => ({
                url: `direct-apm/spayCreateTrx/${id}`,
                method: "POST",
                body: {phoneNumber: phoneNumber}
            }),
        })
    }),
})

export const {
    useGetPaymentQuery,
    useUpdateRedirectPaymentMutation,
    useExecutePaymentMutation,
    usePostePayIGFSMutation,
    usePostePayVerifyIGFSMutation,
    useSpayCreateTrxMutation,
    useSetBrowserInfoMutation,
    useDirectPaymentMutation,
    useGetPaymentOutcomeMutation,
    useGetPaymentSDKQuery,
    useGetIpQuery,
    useCreateOrderPaypalMutation,
    useCaptureOrderPaypalMutation,
    useDeTokenMutation
} = paymentApi;